const LogoWinners = require("../../resources/images/logo.svg");
const Icon_Casino = require("../../resources/icons/casino.webp");

const Rugby = require("../../resources/images/menurugby.svg");
const Dart = require("../../resources/images/menudart.svg");
const Aussie = require("../../resources/images/menuaussierules.svg");
const MMA = require("../../resources/images/menumma.svg");
const Soccer = require("../../resources/images/menusoccer.svg");
const IceHockey = require("../../resources/images/menuicehokey.svg");
const MenuBasketball = require("../../resources/images/menubasketball.svg");
const MenuMMA = require("../../resources/images/menumma.svg");
const MenuTennis = require("../../resources/images/menutennis.svg");
const MenuCricket = require("../../resources/images/menucriket.svg");
const VolleyBall = require("../../resources/images/menuvollyball.svg");

const MyAccountBetsIcon = require("../../resources/images/my-account-bets.svg");
const MyAccountDepositeIcon = require("../../resources/images/my-account-deposite.svg");
const MyAccountWithdrawalIcon = require("../../resources/images/my-account-withdrawal.svg");
const MyAccountChangePasswordIcon = require("../../resources/images/my-account-change-password.svg");
const MyAccountTransactionsIcon = require("../../resources/images/my-account-transactions.svg");
const MyAccountPersonalInfoIcon = require("../../resources/images/my-account-personal-info.svg");
const MyAccountAddProviderIcon = require("../../resources/images/my-account-add-provider.svg");

const LogoWinnersHand = require("../../resources/images/hand.webp");
const DownArrow = require("../../resources/images/chevron-down.svg");
const PlusEighteenDarkMode = require("../../resources/images/plus18.svg");
const BinIcon = require("../../resources/images/delete.svg");
const RedBinIcon = require("../../resources/images/red-trash.svg");

const DarkMoon = require("../../resources/images/dark-moon.svg");

const CloseIcon = require("../../resources/images/close-fill.svg");

const HidePasswordIcon = require("../../resources/images/eye-fill.svg");
const ShowPasswordIcon = require("../../resources/images/eye-fill-white.svg");

const Icon_Home = require("../../resources/icons/home.webp");
const Icon_Favorites = require("../../resources/icons/favorites.webp");
const Icon_Fixture = require("../../resources/icons/fixture.webp");
const Icon_Live = require("../../resources/icons/live.webp");
const Icon_Slots = require("../../resources/icons/slot-machine.webp");
const Icon_Virtual = require("../../resources/icons/virtual.webp");
const Icon_BarChart = require("../../resources/icons/bar-chart-reload.webp");
const LT = require("../../resources/images/lt.webp");

const TopBets1 = require("../../resources/top-bets/studiom1/1.webp");
const TopBets2 = require("../../resources/top-bets/studiom1/2.webp");
const TopBets3 = require("../../resources/top-bets/studiom1/3.webp");

const Strip_Soccer = require("../../resources/images/strip_soccer.webp");
const Strip_Mask = require("../../resources/images/strip_mask.webp");

const CircleCheck = require("../../resources/icons/checkbox-marked-circle.webp");
const Check = require("../../resources/images/check.webp");
const Thumb = require("../../resources/images/thumb.webp");

const NotificationIcon = require("../../resources/images/notification-icon.svg");
const RewardsIcon = require("../../resources/images/rewards-icon.svg");
const SilverStatusImage = require("../../resources/images/silver-status.svg");

const ProgressBarStar = require("../../resources/images/star.svg");

const Image_Maintenence = require("../../resources/images/maintenence.webp");

const WheelSpin = require("../../resources/images/wheel.svg");
const WheelArrow = require("../../resources/images/wheel-arrow.svg");

const Hand = require("../../resources/images/finger.png");
const Shine = require("../../resources/images/shine.png");

const LiveTrackerIcon = require("../../resources/images/live-tracker.png");

const DarkStar = require("../../resources/images/dark-star.png");
const DarkCup = require("../../resources/images/dark-cup.png");

const LoadingBackground = require("../../resources/images/loading-background.png");
const Loading = require("../../resources/images/loading.png");

const InfoIcon = require("../../resources/images/info.svg");
const NoNotification = require("../../resources/images/no-notification.svg");

// test icons
const SoccerTest = require("../../resources/images/Soccer-test.png");
const DummyTeam = require("../../resources/images/Borussia_Dortmund_logo 1.png");

const DeleteIcon = require("../../resources/images/delete.png");
const TurnOffIcon = require("../../resources/images/notification-off.png");
const JackpotFrame = require("../../resources/images/shape.png");
// end of test image

const RotateIcon = require("../../resources/images/rotate.svg");
const LeftArrowIcon = require("../../resources/images/LA.png");
const RightArrowIcon = require("../../resources/images/RA.png");
const LuckyNumberStar = require("../../resources/images/fav-star.svg");
const Calender = require("../../resources/images/calender.png");
const Time = require("../../resources/images/time.png");
const CanceledEvent = require("../../resources/images/canceled-event.png");

const HeartIcon = require("../../resources/images/heart.png");
const ChatIcon = require("../../resources/images/chat.png");
const HomeIcon = require("../../resources/images/home.png");
// end of test Icons

// test banners for slots=
const SlotsTest1 = require("../../resources/images/test1-slots.png");
const SlotsTest2 = require("../../resources/images/test2-slots.png");
const SlotsTest3 = require("../../resources/images/test3-slots.png");
const SlotsTest4 = require("../../resources/images/test4-slots.png");

const AviatorGame = require("../../resources/images/aviator-game.png");
const NewJackpot = require("../../resources/images/new-jackpot.png");
const SpiritEygptGame = require("../../resources/images/sprirt-egypt-game.png");
const SpecialGame = require("../../resources/images/special-game.png");
const Crown = require("../../resources/images/crown.png");
const Joker = require("../../resources/images/joker.png");
const Wolf = require("../../resources/images/wolf.png");
// 

// bet services
const PromotionIcon = require("../../resources/images/promotions.webp");
const LandingIcon = require("../../resources/images/landing.webp");

// 
// general
const PromoIcon = require("../../resources/images/promoIcon.png");
const InfoCircle = require("../../resources/images/info-circle.png");
// 
// verifyEmail
const ConfirmationLogo = require("../../resources/images/confirmation-logo.png");
// 

export default {
  LogoWinners,
  LogoWinnersHand,
  Icon_Home,
  Icon_Favorites,
  Icon_Fixture,
  Icon_Live,
  Icon_Virtual,
  Icon_BarChart,
  Icon_Slots,
  Icon_Casino,

  Image_Maintenence,

  Strip_Soccer,
  Strip_Mask,

  LT,
  DarkMoon,
  CloseIcon,
  HidePasswordIcon,
  ShowPasswordIcon,

  Rugby,
  Dart,
  Aussie,
  MMA,
  Soccer,
  IceHockey,

  MyAccountBetsIcon,
  MyAccountDepositeIcon,
  MyAccountWithdrawalIcon,
  MyAccountChangePasswordIcon,
  MyAccountTransactionsIcon,
  MyAccountPersonalInfoIcon,
  MyAccountAddProviderIcon,

  TopBets1,
  TopBets2,
  TopBets3,

  CircleCheck,
  Check,
  Thumb,

  DownArrow,
  PlusEighteenDarkMode,
  BinIcon,
  RedBinIcon,

  MenuBasketball,
  MenuMMA,
  MenuTennis,
  MenuCricket,
  VolleyBall,

  NotificationIcon,
  RewardsIcon,
  SilverStatusImage,

  ProgressBarStar,
  WheelSpin,
  WheelArrow,

  Hand,
  Shine,

  LiveTrackerIcon,
  DarkStar,
  DarkCup,

  LoadingBackground,
  Loading,

  InfoIcon,
  SoccerTest,
  DummyTeam,

  
  DeleteIcon,
  TurnOffIcon,
  JackpotFrame,

  NoNotification,
  RotateIcon,

  LeftArrowIcon,
  RightArrowIcon,

  LuckyNumberStar,
  Calender,
  Time,
  CanceledEvent,
  HeartIcon,
  ChatIcon,
  HomeIcon,


  SlotsTest1,
  SlotsTest2,
  SlotsTest3,
  SlotsTest4,


  AviatorGame,
  NewJackpot,
  SpiritEygptGame,
  SpecialGame,
  Crown,

  Joker,
  Wolf,
  PromotionIcon,
  LandingIcon,
  PromoIcon,


  ConfirmationLogo,
  InfoCircle
};
